import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { BaseCell } from './BaseCell';

const StyledLinkCell = styled.a`
  align-items: center;
  display: flex;
  font-weight: 600;

  :hover {
    color: inherit;
    text-decoration: underline;
  }
`;

const StyledReactLinkCell = styled(RouterLink)`
  align-items: center;
  display: flex;
  font-weight: 600;

  :hover {
    color: inherit;
    text-decoration: underline;
  }
`;

// type LinkCellProps = {
//   url?: string, // url might be undefined if the value is also a URL
//   value: string,
// };

// // security options for external links: https://developers.google.com/web/tools/lighthouse/audits/noopener
// type LinkCellOptions = {
//   rel: 'noreferrer',
//   target: '_blank',
// };

export const createLinkCell =
  (useBasecell /*: boolean */, options /*: LinkCellOptions */ = {}) =>
  ({ url, value }) => {
    const Link = (
      <StyledLinkCell href={url || value} {...options}>
        {value}
      </StyledLinkCell>
    );

    if (useBasecell) {
      return <BaseCell>{Link}</BaseCell>;
    }

    return Link;
  };

export const ReactLinkCell = ({ url, value }) => (
  <BaseCell>
    <StyledReactLinkCell to={url}>{value}</StyledReactLinkCell>
  </BaseCell>
);

export const LinkCell = createLinkCell(true);
export const ExternalLinkCell = createLinkCell(true, { rel: 'noreferrer', target: '_blank' });
export const CleanLinkCell = createLinkCell(false);
export const CleanExternalLinkCell = createLinkCell(false, { rel: 'noreferrer', target: '_blank' });
